



































import {
  defineComponent,
  watch,
} from '@vue/composition-api';
import { Popup } from '@hb/coffee';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { useRealityMaxQuotaFormatted, useIsRealityQuotaExperimental } from '@/shared/utils/getMaxQuota';
import { reportPopupExposure } from '@/api/popup';
import { PopupIdEnum } from '@/api/popup/types';
import { ubtSendError } from '@/shared/utils/ubt';
import { TP_OCR_RETURN_POPUP_EXPOSE, TP_OCR_RETURN_POPUP_CLICK } from './tianqi';

import '@/components/components.theme.blue.scss';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['confirm', 'cancel', 'close'],
  setup(
    props: {
      show: boolean;
    },
    context: {
      emit: (event: 'confirm' | 'cancel' | 'close') => void;
    },
  ) {
    const maxQuotaFormatted = useRealityMaxQuotaFormatted();
    const isRealityQuotaExp = useIsRealityQuotaExperimental();

    ubtSetupModuleExpose(TP_OCR_RETURN_POPUP_EXPOSE);

    const onConfirmClick = () => {
      context.emit('confirm');
      ubtSetupPageButton(
        TP_OCR_RETURN_POPUP_CLICK,
        {
          confirm: 1,
          buttonName: '继续申请',
        },
      );
    };
    const onCancelClick = () => {
      context.emit('cancel');
      ubtSetupPageButton(
        TP_OCR_RETURN_POPUP_CLICK,
        {
          cancel: 1,
          buttonName: '退出',
        },
      );
    };
    const onCloseClick = () => {
      context.emit('close');
      ubtSetupPageButton(
        TP_OCR_RETURN_POPUP_CLICK,
        {
          close: 1,
          buttonName: '关闭',
        },
      );
    };

    /** 监听 show 变化，当弹窗展示时上报曝光次数+1 */
    watch(
      () => props.show,
      (visible) => {
        if (visible) {
          reportPopupExposure(PopupIdEnum.VERIFY_CREDIT_IDENTITY_BACK, Date.now())
            .catch((error) => ubtSendError({
              name: `reportPopupExposure-error-${PopupIdEnum.VERIFY_CREDIT_IDENTITY_BACK}`,
              message: (error as Error).message,
            }));
        }
      },
    );

    return {
      maxQuotaFormatted,
      isRealityQuotaExp,
      onConfirmClick,
      onCancelClick,
      onCloseClick,
    };
  },
});
